import { memo } from "react";
import { FixedSizeList as VirtualizedList } from "react-window";

import {
  ModalContainer,
  SectionHeader,
  SearchBar,
  CopyButton,
  SwitchAppButton,
} from "../../../../../components";
import { truncateStringWithEllipsis } from "../../../../../utils";
import {
  IBankCodesForBulkUploadViewProps,
  IBankWithShortCodeAndSlug,
} from "./BankCodesForBulkUpload";
import { BankListSkeleton } from "./BankListSkeleton";

export const View = ({
  isModalOpen,
  closeModal,
  downloadCsvBankCodesAndSlugs,
  setSearchBanksText,
  isLoadingBankList,
  filteredBankList,
}: IBankCodesForBulkUploadViewProps) => {
  return (
    <ModalContainer
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      className="bank-codes-container"
      modalHeader={
        <SectionHeader
          title="BANK CODES"
          subtitle="Replace spreadsheet bank fields with either the short-code or slug
              for the bank."
          renderRight={
            <SwitchAppButton
              kind="primary"
              onClick={downloadCsvBankCodesAndSlugs}
              size="sm"
              className="mr-5"
            >
              Download CSV
            </SwitchAppButton>
          }
        />
      }
    >
      <SearchBar
        name="search-banks"
        placeholder="Search banks..."
        onChange={(e: any) => setSearchBanksText(e.target.value)}
        onClear={() => setSearchBanksText("")}
        className="banks-searchbar"
      />

      <div className="cds--structured-list">
        <BankCodesAndSlugStructuredListHeader />

        <div className="mr-5 cds--structured-list-tbody">
          {isLoadingBankList ? (
            <>
              <BankListSkeleton />
              <BankListSkeleton />
              <BankListSkeleton />
              <BankListSkeleton />
              <BankListSkeleton />
            </>
          ) : (
            ""
          )}
          {filteredBankList.map((bank, index) => {
            return (
              <BankCodeWithSlugListItem
                key={bank.bank_code}
                index={index}
                bank={bank}
              />
            );
          })}

          {/* <VirtualizedList
            itemCount={filteredBankList.length}
            itemSize={50}
            height={
              filteredBankList.length
                ? 50 * filteredBankList.length // 800
                : 0
            }
            width={"100%"}
            className="cds--structured-list-tbody"
          >
            {({ index: virtualizedRowIndex, style }) => {
              const bank = filteredBankList[virtualizedRowIndex];

              return (
                <>
                  {virtualizedRowIndex === 0 ? (
                    <BankCodesAndSlugStructuredListHeader />
                  ) : null}

                  <BankCodeWithSlugListItem
                    index={virtualizedRowIndex}
                    bank={bank}
                  />
                </>
              );
            }}
          </VirtualizedList> */}
        </div>
      </div>

      <div className="flex-container row justify-content--center mt-5 mb-5" />
    </ModalContainer>
  );
};

const BankCodesAndSlugStructuredListHeader = () => (
  <div className="cds--structured-list-thead">
    <div className="cds--structured-list-row cds--structured-list-row--header-row">
      <div className="cds--structured-list-th font-ctm--semibold">#</div>

      <div className="cds--structured-list-th">Bank Name</div>

      <div className="cds--structured-list-th">Short Code</div>

      <div className="cds--structured-list-th">Slug</div>
    </div>
  </div>
);

const BankCodeWithSlugListItem = memo(
  ({ index, bank }: { index: number; bank: IBankWithShortCodeAndSlug }) => {
    return (
      <div
        className={`cds--structured-list-row`}
        title={bank.bank_name}
        key={bank.bank_code}
      >
        <div className="cds--structured-list-td font-ctm--semibold text-primary">
          {index + 1}.
        </div>

        <div className="cds--structured-list-td font-ctm--semibold">
          {bank.bank_name}
        </div>

        <div className="cds--structured-list-td" title={bank.bank_code}>
          <div className="flex-container justify-content--end align-items--center no-wrap">
            <div className="transaction-id-text modal-header--title">
              <span title={bank.bank_code}>{bank.bank_code}</span>
            </div>
            <div className="copy-button--container ml-3">
              <CopyButton
                name="copy-bank_code-button"
                stringToCopy={bank.bank_code}
                iconDescription="copy bank code"
                className="copy-btn"
              />
            </div>
          </div>
        </div>

        <div className="cds--structured-list-td" title={bank.slug}>
          <div className="flex-container justify-content--start align-items--center no-wrap">
            <div className="transaction-id-text modal-header--title">
              <span title={bank.slug}>
                {truncateStringWithEllipsis(bank.slug, 150)}
              </span>
            </div>
            <div className="copy-button--container ml-3">
              <CopyButton
                name="copy-reference-button"
                stringToCopy={bank.slug}
                iconDescription="copy bank slug"
                className="copy-btn"
              />
            </div>
          </div>
        </div>
      </div>
    );
  },
  (prevProps, nextProps) =>
    prevProps.bank.bank_code === nextProps.bank.bank_code
);
